import isValidNumericString from 'src/util/isValidNumericString';
import removeNonNumericCharacters from 'src/util/removeNonNumericCharacters';

/**
 * Formats a string as a currency with no decimal points
 * @param {string} strCurrVal - The string to be formatted as a currency
 * @returns {string} - The formatted currency string or an empty string if the input is not a valid number
 */
export default function formatCurrency(strCurrVal) {
  const cleanedVal = removeNonNumericCharacters(strCurrVal);
  if (!cleanedVal) return '';
  if (!isValidNumericString(cleanedVal)) return '';

  let cents = '';
  let dollar = cleanedVal;

  // If there is a decimal point, split the string into dollars and cents
  const hasCents = strCurrVal.indexOf('.') !== -1;
  if (hasCents) {
    cents = removeNonNumericCharacters(strCurrVal.split('.')[1]);
    dollar = removeNonNumericCharacters(strCurrVal.split('.')[0]);
    // If there are more than 2 decimal places, truncate to 2
    cents = cents.slice(0, 2);
  }

  // Format the dollar amount
  const dollarAmount = parseFloat(dollar).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  // If there are cents, add them to the formatted dollar amount
  return `${dollarAmount}${hasCents ? `.${cents}` : ''}`;
}
